import{a as o}from"./chunk-IHEQMC3B.js";import{w as e}from"./chunk-YWCHHP5N.js";import{a as r,m as t}from"./chunk-HBP5N4FR.js";t();import T from"axios";var u=({hash:i,apiAddress:n,apiTimeout:a})=>T.get(`${n}/${e}/${i}`,r({},o(a)));export{u as a};
//# sourceMappingURL=chunk-OEQBSYNW.js.map
